"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGooglePayEnv = exports.getAdyenEnv = exports.getAdyenClientKey = void 0;
var _appConfigHelper = require("../../../util/appConfigHelper");
const CLIENT_KEY_LIVE = 'live_BQDOFBYTGZB3XKF62GBYSLPUJ4YW2TPL';
const CLIENT_KEY_TEST = 'test_I4OFGUUCEVB5TI222AS3N2Y2LY6PJM3K';
const getAdyenEnv = () => (0, _appConfigHelper.getData)('CLEENG_ENVIRONMENT') !== 'production' ? 'test' : 'live';
exports.getAdyenEnv = getAdyenEnv;
const getAdyenClientKey = () => getAdyenEnv() === 'test' ? CLIENT_KEY_TEST : CLIENT_KEY_LIVE;
exports.getAdyenClientKey = getAdyenClientKey;
const getGooglePayEnv = () => getAdyenEnv() === 'test' ? 'TEST' : 'PRODUCTION';
exports.getGooglePayEnv = getGooglePayEnv;